import {
	Layout,
	Row,
	Col,
	Card,
	Typography,
	Divider,
	Form,
	Input,
	message,
	Checkbox,
	Button
} from 'antd';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { LockOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { login, unSubscribe } from '../../store/auth/actions';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
import { env } from '../../environment';

const logoBE = require('../../assets/onboarding/logoBE.png');
const EV = require('../../assets/EngelLogo.png');
const EVMoBile = require('../../assets/EngelLogoMobile.png');

const { Content } = Layout;
const { Text } = Typography;

const UnSubscribe = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [searchParams] = useSearchParams();
	const token = searchParams.get('token');
	const email = searchParams.get('email');
	const navigate = useNavigate();

	const [check1, setCheck1] = useState(false);
	const [check2, setCheck2] = useState(false);

	const onFinish = async (values) => {
		values.check1 = check1;
		values.check2 = check2;
		let tmpCheck = undefined;
		if (values.check1 && values.check2) {
			tmpCheck = 'both';
		} else if (values.check1 && values.check2 === false) {
			tmpCheck = 'transactional';
		} else {
			tmpCheck = 'comercial';
		}
		const tmp = await dispatch(unSubscribe(token, values.username, tmpCheck));

		if (tmp) {
			navigate('/login');
			message.success('Baja registrada');
		}
	};

	const onFinishFailed = () => {
		message.error('Debe completar todos los datos');
	};

	return (
		<Layout
			style={{
				width: isMobileOnly ? 400 : undefined,
				marginTop: -5,
				background: '#FCFAF5'
			}}>
			<div style={{ height: isMobileOnly ? 56 : 68, background: 'white' }}>
				<div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
					{isMobileOnly ? (
						<img src={EVMoBile} alt="EV" style={{ width: 109, height: 24 }}></img>
					) : (
						<img src={EV} alt="EV" style={{ width: 212, height: 16 }}></img>
					)}
				</div>
			</div>
			<Content
				style={{
					marginTop: !isMobileOnly ? '5%' : undefined,

					height: !isMobileOnly ? '100vh' : undefined,
					padding: isMobileOnly && 24,
					height: '100vh',
					marginRight: !isMobileOnly ? undefined : 8
				}}>
				<div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
					<Text style={{ fontSize: isMobileOnly ? 20 : 32, fontWeight: 700, color: '#262626' }}>
						{t('text.down')}
					</Text>
				</div>
				<Row justify="space-around" align="middle">
					<Col lg={6} md={12} xs={24} sm={24}>
						<Card className="card-login">
							<div style={{ marginBottom: 24 }}>
								<Text style={{ fontSize: 16, fontWeight: 400, color: '#808080' }}>
									{t('text.downSelect')}
								</Text>
							</div>
							<Form
								initialValues={{
									username: email
								}}
								name="login"
								onFinish={onFinish}
								onFinishFailed={onFinishFailed}>
								<Form.Item
									name="username"
									rules={[{ required: true, message: 'Introduzca su email' }]}>
									<Input className={'login-input'} type="email" placeholder={t('Email') + '*'} />
								</Form.Item>

								<Form.Item name="transactional">
									<Checkbox onChange={() => setCheck1(!check1)}>
										{
											<Text style={{ fontSize: 16, fontWeight: 400, color: '#404040' }}>
												{t('check.text1')}
											</Text>
										}
									</Checkbox>
								</Form.Item>
								<Form.Item name="comercial">
									<Checkbox onChange={() => setCheck2(!check2)}>
										{
											<Text style={{ fontSize: 16, fontWeight: 400, color: '#404040' }}>
												{t('check.text2')}
											</Text>
										}
									</Checkbox>
								</Form.Item>

								<Form.Item>
									<Button
										htmlType="submit"
										block
										className="button-secundary-ev"
										style={{ height: isMobileOnly && 48 }}>
										{t('init.continueEV')}
									</Button>
								</Form.Item>
							</Form>
						</Card>
					</Col>
				</Row>
			</Content>
		</Layout>
	);
};

export default UnSubscribe;
